import type { BasketByLimit, BasketByType } from "lib/apollo/types"
import { getInitialLimit } from "./getInitialLimit"

export const getBasketByLimit = (
  bucketedBasket: BasketByType
): BasketByLimit => {
  const initialLimit = getInitialLimit(bucketedBasket)

  const {
    memberships = [],
    giftMemberships = [],
    products = [],
  } = bucketedBasket
  const inLimitItemMap = new Map()
  const inLimitItemArr: string[] = []
  const outOfLimitItemMap = new Map()
  const outOfLimitItemArr: string[] = []

  for (const item of products) {
    const variantId = item.variant?.id ?? ""

    inLimitItemArr.push(`${variantId}-${item.origin}`)
    inLimitItemMap.set(`${variantId}-${item.origin}`, item)
  }

  const outOfLimitProducts = outOfLimitItemArr.map((v) =>
    outOfLimitItemMap.get(v)
  )
  const inLimitProducts = inLimitItemArr.map((v) => inLimitItemMap.get(v))

  return {
    initialLimit,
    remainingLimit: Infinity,
    inLimitItems: [...memberships, ...giftMemberships, ...inLimitProducts],
    outOfLimitItems: outOfLimitProducts,
  }
}
